<template>
  <section class="app-main" :style="{ height: height }">
    <router-view>
      <template #default="{ Component, route }">
        <transition
          enter-active-class="animate__animated animate__fadeIn"
          mode="out-in"
        >
          <keep-alive :include="cachedViews">
            <component :is="Component" :key="route.path" />
          </keep-alive>
        </transition>
      </template>
    </router-view>
  </section>
</template>

<script setup lang="ts">
import variables from "@/styles/variables.module.scss";
import { useAppStore } from "@/stores";

const appStore = useAppStore();
// 缓存页面集合
const cachedViews = computed(() => []);
const height = computed(() => {
  return appStore.showLayout
    ? `calc(100vh - ${variables["navbar-height"]} - 4px)`
    : "100%";
});
</script>

<style lang="scss" scoped>
.app-main {
  position: relative;
  background-color: var(--el-bg-color-page);
  overflow-y: auto;
  box-sizing: border-box;
}
</style>
